/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// START custom add to cart functionality to support selling TTC subs on digital.trxtraining.com
function displayLoader () {
  $("#cart-spinner").show();
}

function hideLoader () {
  $("#cart-spinner").hide();
}

function handleTTCSubs() {
  var searchParams = new URLSearchParams(window.location.search);

  const isCartPage = window.location.pathname === '/cart';
  const idParam = searchParams.get('id');
  const quantityParam = searchParams.get('quantity');
  const sellingPlanParam = searchParams.get('selling_plan');
  const hasRequiredQueryParams = !!idParam && !!quantityParam && !!sellingPlanParam

  console.log({ isCartPage, hasRequiredQueryParams })

  if (isCartPage && hasRequiredQueryParams) {
    displayLoader();
    const data = {
      id: idParam,
      quantity: quantityParam,
      selling_plan: sellingPlanParam
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        logDatadog('success; handleTTCSubs; data: ' + JSON.stringify(data));
        hideLoader();
        window.location.href = '/cart';
      },
      error: function() {
        logDatadog('error; handleTTCSubs; data: ' + JSON.stringify(data));
        hideLoader();
        console.log({ error: true });
        window.location.href = '/collections/subscriptions';
      }
    });
  }
}
handleTTCSubs();
// END custom add to cart functionality to support selling TTC subs on digital.trxtraining.com


// START - custom form submission on main-customers-activate-account
$(document).ready(function() {
  var $errorContainer = $('#activate-account-error-3d5c6a1c')
  var $errorMessage = $('#activate-account-error-3d5c6a1c > .banner__content')
  var $submitButton = $('#submit-button-3d5c6a1c')

  function hideErrorContainer () {
    $errorContainer.hide()
  }

  function displayErrorContainer () {
    $errorContainer.show()
  }

  function updateErrorMessage (val) {
    $errorMessage.text(val)
  }

  hideErrorContainer();

  function validate({ customerPassword, customerPasswordConfirmation }) {
    if (
      customerPassword !== customerPasswordConfirmation
    ) {
      return 'Passwords don\'t match'
    }

    if (
      customerPassword.length < 6 ||
      customerPasswordConfirmation < 6
    ) {
      return 'Please enter at least 6 characters'
    }

    return null
  }

  function handleSubmit() {
    $("#loading-spinner").show();

    var $customerPassword = $('#customer_password_3d5c6a1c')
    var $customerPasswordConfirmation = $('#customer_password_confirmation_3d5c6a1c')

    var customerPassword = $customerPassword.val()
    var customerPasswordConfirmation = $customerPasswordConfirmation.val()

    var errorMessage = validate({ customerPassword, customerPasswordConfirmation })
    if (errorMessage) {
      displayErrorContainer()
      updateErrorMessage(errorMessage)
      $("#loading-spinner").hide();
    } else {
      hideErrorContainer()
      var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          password: customerPassword,
          activation_url: window.location.href
        })
      };

      var url = 'https://trx-carabiner.herokuapp.com/api/v1/shopify/account/activate'

      fetch(url, requestOptions)
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (
            data &&
            data.access_token &&
            data.email &&
            data.status === true
          ) {
            logDatadog('success handleSubmit /api/v1/shopify/account/activate');
            exchangeMultipassToken(data.access_token, data.email)
          } else {
            displayErrorContainer()
            updateErrorMessage("Error activation account. Please try again or contact support@trxtraining.com")
            $("#loading-spinner").hide();
            logDatadog('error handleSubmit /api/v1/shopify/account/activate');
          }
        })
    }
  }

  $submitButton.on('click', handleSubmit)
})
// END - custom form submission on main-customers-activate-account

// START - gift with purchase custom logic
function isEuSite () {
  return window.location.origin.endsWith('.eu')
}

function isUkSite () {
  return window.location.href.split('-gb/').length === 2
}

function getGiftWithPurchaseGiftItem () {
  var currentNewYorkTimeFormatted = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
  var currentNewYorkTimeObject = new Date(currentNewYorkTimeFormatted);

  var currentNewYorkMonth = currentNewYorkTimeObject.getMonth() + 1;
  var currentNewYorkDay = currentNewYorkTimeObject.getDate();
  var currentNewYorkYear = new Date().toLocaleString("en-US", { timeZone: "America/New_York", year: "numeric" });

  var giftWithPurchaseGiftItems = {
    xmount: {
      month: 11,
      dayStart: 14,
      dayEnd: 19,
      sku: 'TRXXMOUNT4-WHITE',
      href: '/products/xmount?variant=40006818988172',
      variantId: 40006818988172,
      qualifyingAmount: 17500,
      freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX XMount 🎁 🎁<p>"
    },
    duffle2: {
      month: 11,
      dayStart: 20,
      dayEnd: 22,
      sku: 'DUFFLELOGO-CNS-CHR',
      href: '/products/performance-duffle',
      variantId: 39836064972940,
      qualifyingAmount: 20000,
      freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX Performance Duffle 🎁 🎁<p>"
    },
    yeti: {
      month: 12,
      dayStart: 5,
      dayEnd: 18,
      sku: 'YETIBTL',
      href: '/products/trx-x-yeti-yonder-water-bottle',
      variantId: 43452277719180,
      qualifyingAmount: 20000,
      freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX x YETI Yonder Water Bottle 🎁 🎁<p>"
    },
    bands: {
      month: 12,
      dayStart: 19,
      dayEnd: 22,
      sku: 'TRX-ER-MNBD-BDL-B',
      href: '/products/exercise-bands?variant=40995794256012',
      variantId: 40995794256012,
      qualifyingAmount: 15000,
      freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX Exercise Bands 🎁 🎁<p>"
    },
    xmount3: {
      month: 1,
      dayStart: 2,
      dayEnd: 29,
      sku: 'TRXXMOUNT3',
      href: "/products/trx-xmount3?variant=43619720790156",
      variantId: 43619720790156,
      freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX XMount3 🎁 🎁<p>",
      purchaseVariantIds: [
        41971334217868,
        43232205930636,
        43239838318732,
        43239838285964,
        43232205897868
      ]
    },
    yeti2: {
      month: 2,
      dayStart: 1,
      dayEnd: 26,
      sku: 'YETIBTL',
      href: '/products/trx-x-yeti-yonder-water-bottle',
      variantId: 43452277719180,
      qualifyingAmount: 25000,
      freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX x YETI Yonder Water Bottle 🎁 🎁<p>"
    },
  }
  if (isEuSite()) {
    giftWithPurchaseGiftItems = {
      xmount: {
        month: 11,
        dayStart: 14,
        dayEnd: 22,
        sku: 'TRXXMOUNT4-WHITE',
        href: '/products/xmount?variant=40251582709849',
        variantId: 40251582709849,
        qualifyingAmount: 17000,
        freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX XMount 🎁 🎁<p>"
      },
      bands: {
        month: 12,
        dayStart: 5,
        dayEnd: 18,
        sku: 'TRX-ER-MNBD-BDL-B',
        href: '/products/trx-exercise-bands?variant=40172428525657',
        variantId: 40172428525657,
        qualifyingAmount: 15000,
        freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX Exercise Bands 🎁 🎁<p>"
      },
      mat: {
        month: 12,
        dayStart: 19,
        dayEnd: 22,
        sku: 'EXMAT',
        href: '/products/mat',
        variantId: 39869933518937,
        qualifyingAmount: 15000,
        freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX Mat 🎁 🎁<p>"
      },
      bands2: {
        month: 1,
        dayStart: 2,
        dayEnd: 29,
        sku: 'TRX-ER-MNBD-BDL-B',
        href: '/products/trx-exercise-bands?variant=40172428525657',
        variantId: 40172428525657,
        freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX Exercise Bands 🎁 🎁<p>",
        purchaseVariantIds: [
          49316111188305,
          40299264442457,
          49316197859665,
          49316147331409
        ]
      },
      bands3: {
        month: 2,
        dayStart: 1,
        dayEnd: 26,
        sku: 'TRX-ER-BAND-25/50',
        href: '/products/strength-bands?variant=40250056966233',
        variantId: 40250056966233,
        qualifyingAmount: 15000,
        freeCartCopy: "<p><span style='text-decoration:underline'>Click here</span> to claim your free TRX Exercise Bands 🎁 🎁<p>"
      },
    }
  }

  var giftItemsKeys = Object.keys(giftWithPurchaseGiftItems);
  var matchingGiftItem;

  for (var i = 0; i < giftItemsKeys.length; i++) {
    if ( !matchingGiftItem) {
      var giftItemsKey = giftItemsKeys[i];
      var giftItemData = giftWithPurchaseGiftItems[giftItemsKey];
      var isMatchingGiftItem = false;

      if (
        new Date(currentNewYorkYear, giftItemData.month - 1, giftItemData.dayStart) <= new Date(currentNewYorkYear, currentNewYorkMonth - 1, currentNewYorkDay) &&
        (
          !giftItemData.dayEnd ||
          new Date(currentNewYorkYear, giftItemData.month - 1, giftItemData.dayEnd) >= new Date(currentNewYorkYear, currentNewYorkMonth - 1, currentNewYorkDay)
        )
      ) {
        isMatchingGiftItem = true;
      }


      if (isMatchingGiftItem) {
        matchingGiftItem = giftItemData
      }
    }
  }

  console.log({ matchingGiftItem });
  return matchingGiftItem;
}

function cartContainsEligibleGiftWithPurchaseItem ({ cartData }) {
  var giftItem = getGiftWithPurchaseGiftItem();

  if (!giftItem) {
    return false;
  }

  var cartLineItems = cartData.items;

  if (cartLineItems.length === 0) {
    return false;
  }

  var matchingPurchaseItemInCart = cartLineItems.find(function(lineItem) {
    return lineItem && lineItem.variant_id && giftItem.purchaseVariantIds && giftItem.purchaseVariantIds.includes(lineItem.variant_id)
  })

  return !!matchingPurchaseItemInCart;
}

function cartContainsGiftWithPurchaseGiftItem ({ cartData }) {
  var giftItem = getGiftWithPurchaseGiftItem();

  if (!giftItem) {
    return false;
  }

  var cartLineItems = cartData.items;

  if (cartLineItems.length === 0) {
    return false;
  }

  var matchingGiftItemInCart = cartLineItems.find(function(lineItem) {
    return lineItem && lineItem.variant_id && (lineItem.variant_id === giftItem.variantId);
  })

  return !!matchingGiftItemInCart;
}

function handleCartDataForGWP ({ cartData }) {
  var giftItem = getGiftWithPurchaseGiftItem();

  if (!giftItem) {
    logDatadog('giftWithPurchase; handleCartDataForGWP; !giftItem');
    return;
  } else {
    logDatadog('giftWithPurchase; handleCartDataForGWP; giftItem');
  }

  if (cartData.items === undefined) {
    logDatadog('giftWithPurchase; handleCartDataForGWP; cartData.items === undefined');
    return;
  }

  var total_price = cartData.total_price;
  var _cartContainsGiftItem = cartContainsGiftWithPurchaseGiftItem({ cartData: cartData });
  var _cartContainsEligibleGiftWithPurchaseItem = cartContainsEligibleGiftWithPurchaseItem({ cartData: cartData });

  var $minicartContainer = $('#holiday-gwp-2022-container');
  var $maincartContainer = $('#holiday-gwp-2022-container-maincart');

  $maincartContainer.empty();
  $minicartContainer.empty();

  if (cartData.item_count) {
    console.log({ total_price, _cartContainsGiftItem, _cartContainsEligibleGiftWithPurchaseItem, giftItem });
    logDatadog('giftWithPurchase; handleCartDataForGWP; total_price');

    if (giftItem.qualifyingAmount) {
      
      var qualifyingAmountCopy = `${giftItem.qualifyingAmount}`
      qualifyingAmountCopy = qualifyingAmountCopy.substring(0, qualifyingAmountCopy.length - 2);

      var isCartPage = window.location.pathname.startsWith('/cart')

      if (total_price < giftItem.qualifyingAmount) {
        logDatadog('holiday2022; handleCartDataForGWP; total_price < giftItem.qualifyingAmount; start');
        
        var copy = `<p>&#x1F381; Free gift on orders over $${qualifyingAmountCopy}. Add additional product(s) to qualify. &#x1F381;</p>`

        if (!isCartPage) {
          waitForElm(`#holiday-gwp-2022-container`).then(function () {
            setTimeout(function () {
              var $minicartContainer = $('#holiday-gwp-2022-container');
              if ($minicartContainer.length) {
                $minicartContainer.empty();
                logDatadog('holiday2022; handleCartDataForGWP; total_price < giftItem.qualifyingAmount; $minicartContainer.length');
                $minicartContainer.append(function () {
                  return $(copy).click(handleClickForGWPPlaceholderText)
                });
              }
            }, 1000)
          })
        }
        if ($maincartContainer.length) {
          logDatadog('holiday2022; handleCartDataForGWP; total_price < giftItem.qualifyingAmount; $maincartContainer.length');
          $maincartContainer.append(copy);
        }
      } else if (total_price >= giftItem.qualifyingAmount && !_cartContainsGiftItem) {
        logDatadog('holiday2022; handleCartDataForGWP; total_price >= giftItem.qualifyingAmount && !_cartContainsGiftItem; start');
        var autoAddLink = `${window.themeVariables.routes.rootUrlWithoutSlash}/cart/add?id=${giftItem.variantId}&quantity=1`;
        var handler = function() {handleClickForGWP({ href: autoAddLink })};
        var copy = giftItem.freeCartCopy;

        if (!isCartPage) {
          waitForElm(`#holiday-gwp-2022-container`).then(function () {
            setTimeout(function () {
              var $minicartContainer = $('#holiday-gwp-2022-container');
              if ($minicartContainer.length) {
                $minicartContainer.empty();
                logDatadog('holiday2022; handleCartDataForGWP; total_price >= giftItem.qualifyingAmount && !_cartContainsGiftItem; $minicartContainer.length');
                $minicartContainer.append(function () {
                  return $(copy).click(handler);
                });
              }
            }, 1000)
          })
        }
        if ($maincartContainer.length) {
          logDatadog('holiday2022; handleCartDataForGWP; total_price >= giftItem.qualifyingAmount && !_cartContainsGiftItem; $maincartContainer.length');
          $maincartContainer.append(function () {
            return $(copy).click(handler);
          });
        }
      }


    } else if (_cartContainsEligibleGiftWithPurchaseItem && !_cartContainsGiftItem) {
      logDatadog('giftWithPurchase; handleCartDataForGWP; _cartContainsEligibleGiftWithPurchaseItem && !_cartContainsGiftItem; start');
      var autoAddLink = `${window.themeVariables.routes.rootUrlWithoutSlash}/cart/add?id=${giftItem.variantId}&quantity=1`;
      var handler = function() {handleClickForGWP({ href: autoAddLink })};
      var copy = giftItem.freeCartCopy;

      if (!isCartPage) {
        waitForElm(`#holiday-gwp-2022-container`).then(function () {
          setTimeout(function () {
            var $minicartContainer = $('#holiday-gwp-2022-container');
            if ($minicartContainer.length) {
              $minicartContainer.empty();
              logDatadog('giftWithPurchase; handleCartDataForGWP; _cartContainsEligibleGiftWithPurchaseItem && !_cartContainsGiftItem; $minicartContainer.length');
              $minicartContainer.append(function () {
                return $(copy).click(handler);
              });
            }
          }, 1000)
        })
      }
      if ($maincartContainer.length) {
        logDatadog('giftWithPurchase; handleCartDataForGWP; _cartContainsEligibleGiftWithPurchaseItem && !_cartContainsGiftItem; $maincartContainer.length');
        $maincartContainer.append(function () {
          return $(copy).click(handler);
        });
      }
    }
  } else {
    logDatadog('giftWithPurchase; handleCartDataForGWP; !total_price');
  }
}

var loadingRedirectForGWP = false;
function handleClickForGWP ({ href }) {
  if (!loadingRedirectForGWP) {
    logDatadog('holiday2022; handleClickForGWP; !loadingRedirectForGWP');
    localStorage.setItem('set2022gwpItem', true)
    window.location.href = href;
    loadingRedirectForGWP = true;
  } else {
    logDatadog('holiday2022; handleClickForGWP; loadingRedirectForGWP');
  }
}

function handleClickForGWPPlaceholderText () {
  if (isEuSite()) {
    window.location.href = `/en-gb/collections/all-products`;
  } else {
    window.location.href = `/collections/all-products`;
  } 
}

$(document).ready(function() {
  var giftItem = getGiftWithPurchaseGiftItem();

  if (!giftItem) {
    logDatadog('giftWithPurchase; $(document).ready; !giftItem');
    return;
  } else {
    logDatadog('giftWithPurchase; $(document).ready; giftItem');
  }

  var set2022gwpItem = localStorage.getItem('set2022gwpItem');
  localStorage.removeItem('set2022gwpItem');
  console.log({ set2022gwpItem });
  if (set2022gwpItem === 'true') {
    logDatadog('giftWithPurchase; $(document).ready; set2022gwpItem');
    if (typeof startConfetti === 'function' && typeof stopConfetti === 'function') {
      startConfetti();
      setTimeout(function () {
        stopConfetti();
      }, 2000)
    }
  }

  fetch(`${window.themeVariables.routes.cartUrl}.js`)
    .then(function(response) { return response.json(); })
    .then(function(data) {
      console.log({ data });
      logDatadog('giftWithPurchase; $(document).ready; data');
      return handleCartDataForGWP({ cartData: data });
    });
})
// END - gift with purchase custom logic holidays 2022

// START hide ATC of giftcard holiday 2022
(function () {
  $(document).ready(function () {
    if (window.location.pathname.endsWith('/products/giftcard')) {
      $('[data-product-add-to-cart-button]').hide()
      $('.product-sticky-form').hide()
    }
  })
}());

(function () {
  $(document).ready(function () {
    if (window.location.pathname.includes('/account')) {
      var count = 0;
      var intervalId = setInterval(function () {
        if (count > 25) {
          clearInterval(intervalId);
          return
        }

        count++

        if ($('#Rise-account-page-button').length) {
          $('#Rise-account-page-button').detach().prependTo('.link-bar__linklist.list--unstyled');
          clearInterval(intervalId);
          return
        }
      }, 200)
    }
  })
}());
// END hide ATC of giftcard holiday 2022
